<template>
  <div>
    <div class="module-one">
      <div class="asset-section">
        <div class="asset-info" ref="assetInfo">
          <img src="@/assets/imgs/home/zc.png" alt="Asset Info" class="asset-image">
        </div>
      </div>
      <div class="asset-section-content">
        <h1>{{ $t('cryptoOneModule.title') }}</h1>
        <p>{{ $t('cryptoOneModule.subTitle') }}</p>
      </div>
    </div>
    <div class="module-two">
      <div class="asset-section">
        <img src="@/assets/imgs/home/sy.png" alt="Asset Info" class="asset-image">
      </div>
      <div class="asset-section-content">
        <h1>{{ $t('cryptoTwoModule.title') }}</h1>
        <p>{{ $t('cryptoTwoModule.subTitle') }}</p>
      </div>
    </div>

    <div class="module-three">
      <div class="title">{{ $t('cryptoThreeModule.title') }}</div>
      <div class="feature">
        <div class="feature-item" v-for="(feature, index) in $t('cryptoThreeModule.threeList')" :key="index">
          <div class="feature-content">{{ feature.content }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "index",
  data() {
    return {
      threeList: [
        {
          content: '低费用'
        },
        {
          content: '去中心化'
        },
        {
          content: '支持70多个币种'
        },
        {
          content: '无退款'
        },
        {
          content: '即时结算'
        },
        {
          content: '无边界全球支付'
        },
        {
          content: '加密货币转换'
        },
        {
          content: 'Fiat On & Off Ramps'
        },
        {
          content: '24/7在线客服支持'
        },
        {
          content: '降低欺诈风险'
        },
      ]
    };
  },
  computed: {},
  methods: {},
  mounted() {

  },
};
</script>
<style scoped lang="less">
.module-one {
  position: relative;
  min-height: 600px;
  display: flex;
  align-items: center;
  justify-content: center;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: 25%;
    background-image: url('~@/assets/imgs/home/zcbg.png');
    background-size: cover;
    background-position: center;
    z-index: 0;
  }

  .asset-section {
    text-align: center;
    align-content: center;
    height: 450px;
    width: 50%;
    margin: 50px auto;
    z-index: 1;
    overflow: hidden;

    .asset-info {
      animation: scrollUp 5s linear infinite;
    }

    .asset-image {
      width: 400px;
      height: auto;
    }

    @keyframes scrollUp {
      0% {
        transform: translateY(30%);
      }
      100% {
        transform: translateY(-10%);
      }
    }
  }

  .asset-section-content {
    width: 50%;
    text-align: center;
    align-content: center;
    z-index: 100;
    h1 {
      font-size: 48px;
      padding: 30px;
    }

    p {
      font-size: 28px;
      padding: 30px;
    }
  }
}

.module-two {
  height: 550px;
  display: flex;
  align-items: center;
  justify-content: center;

  .asset-section {
    text-align: center;
    align-content: center;
    height: 500px;
    width: 50%;
    margin: 50px auto;
    z-index: 1;
    overflow: hidden;

    .asset-image {
      width: 400px;
      height: auto;
    }
  }

  .asset-section-content {
    width: 50%;
    text-align: center;
    align-content: center;

    h1 {
      font-size: 48px;
      margin-bottom: 30px;
    }

    p {
      font-size: 28px;
    }
  }
}

.module-three {
  background-color: #f8f9ff;

  .title {
    text-align: center;
    font-size: 40px;
    font-weight: 500;
    padding: 40px 0;
    align-content: center;
  }
  .feature {
    display: flex;
    flex-wrap: wrap; /* 允许换行 */
    justify-content: flex-start; /* 左对齐排列 */
    gap: 10px; /* 可选：设置子元素之间的间距 */
    padding-bottom: 40px;
    .feature-item {
      flex: 0 0 calc(33.33% - 10px); /* 每排3个，减去gap带来的间距影响 */
      box-sizing: border-box;
      margin-bottom: 20px;
    }

    .feature-content {
      width: 50%;
      border: 1px solid #e6e6e6;
      height: 46px;
      background-color: #fff;
      text-align: center;
      align-content: center;
      margin: 0 auto;
    }
  }
}
</style>
